<template>
  <v-app>
    <!-- <EmailCollector v-model="popup" @close="showModal(false)"> -->
    <EmailCollector ref="dialog" @close="showModal(false)"> </EmailCollector>
    <v-toolbar app>
      <v-toolbar-title fill-height id="logoHolder" class="headline">
        <!-- <img to="/" id="toolbarLogo" src="./assets/logo.png"> -->
        <router-link to="/" tag="div">
          <v-layout align-center>
            <img
              class="toolbarLogo hidden-xs-only"
              to="/"
              src="./assets/logowithName 1.5 website.png"
            />
            <img
              class="toolbarLogo hidden-sm-and-up"
              to="/"
              src="./assets/logo website.png"
            />
            <!-- <img to="/" id="toolbarLogo" src="./assets/logo.png"> -->
            <!-- <div flat x-large id="toolbarName">Dersom Publishing</div> -->
          </v-layout>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="hidden-sm-and-down" @click.native="window._paq.push(['trackEvent', 'Subscription', 'Click', 'sendinbluebutton']);showModal(true)" color="info">Sign up for updates!</v-btn>

      <v-toolbar-items>
        <v-btn to="/" flat>Home</v-btn>
        <v-btn to="/music" flat>Music</v-btn>
        <v-btn to="/contact" flat>Contact</v-btn>
      </v-toolbar-items>
      <!-- <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list class="pa-2">
          <v-list-tile to="/" avatar>
            <v-list-tile-action class="tileAction">
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>Home</v-list-tile-content>
          </v-list-tile>
          <v-list-tile to="/music">
            <v-list-tile-action class="tileAction">
              <v-icon>library_music</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>Music</v-list-tile-content>
          </v-list-tile>
          <v-list-tile to="/contact">
            <v-list-tile-action class="tileAction">
              <v-icon>email</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>Contact</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu> -->
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <!-- <script type="application/javascript"
      src="https://cdn.websitepolicies.io/lib/cookieconsent/1.0.3/cookieconsent.min.js"
      defer
    ></script>
    <script type="application/javascript">
      window.addEventListener("load", function () {
        window.wpcc.init({
          border: "thin",
          corners: "small",
          colors: {
            popup: {
              background: "#222222",
              text: "#ffffff",
              border: "#b3d0e4",
            },
            button: { background: "#b3d0e4", text: "#000000" },
          },
          content: {
            href: "https://sonive.com/privacy",
            message:
              "We use cookies to ensure you get the best experience on our website.",
          },
        });
      });
    </script> -->
    <cookie-law position="bottom" transitionName="slideFromBottom" buttonText="Okay, I agree" v-on:accept="setIFrames(true)"
      theme="dark-lime">
      <div slot="message">
        <div style="z-index: 1000; max-width: 1500px;">
        By using this site, you consent to the use of cookies/data collection by us or third parties for site management, and useful services. For more information, see our <router-link to="/privacy">Privacy Policy and Disclaimer</router-link>
        </div>
      </div>
    </cookie-law>

    <v-footer color="grey darken-3">
      <v-layout justify-center>
        <div id="copyright" style="font-size: 11px">
          &copy;2025 Sonive Publishing -&nbsp;
        </div>
        <router-link to="/privacy" style="font-size: 11px"
          >Privacy Policy and Disclosure</router-link
        >
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import EmailCollector from "./components/EmailCollector";
import CookieLaw from "vue-cookie-law";

export default {
  name: "App",
  components: {
    EmailCollector,
    CookieLaw,
  },
  // props: {
  //   // return {
  //     showCollector: String
  //   // };
  // },
  data() {
    return {
      popup: false,
    };
  },

  // computed: {
  //     return showCollector

  // },

  methods: {
    showModal(isOn) {
      this.popup = isOn;
      // if(isOn){
      this.$refs.dialog.dialog = isOn;
      // }
      // console.log(isOn)
    },
    setIFrames(isOn) {
      this.$root.setIFrames(isOn);
    },
  },

  mounted() {
    this.$root.checkCookie();

    // for(let i = 0; i < cookies; i++){

    //   name = cookies[i].split("=")[0];
    //   print(name)
    //   if(name == "cookie:accepted"){
    //     if(cookies[i].split("=")[1] == true)
    //       setIFrames(true)
    //     break;
    //   }
    // }
  },
};
</script>

<style>
#app {
  font-family: "Open Sans", sans-serif;
}
.toolbarLogo {
  height: 40px;
  margin: 5px 0 5px 0;
  cursor: pointer;
}

#toolbarName {
  float: right;
  cursor: pointer;
  padding-left: 10px;
  font-weight: bold;
}

#copyright {
  color: white;
}

.tileAction {
  min-width: 40px;
}

.activeButton:before {
  background-color: inherit;
}

.Cookie__buttons {
  margin-left: 5% !important;
  margin-right: 7% !important;
  margin-top: 0% !important;
}

.Cookie__content {
  margin-left: 7% !important;
  margin-right: 2% !important;
  font-size: 12px;
}

.Cookie__button {
  background: #0077dd !important;
}

.Cookie__button:hover {
  background: rgb(0, 194, 243) !important;
}
</style>
